<div class="content" [formGroup]="enrollmentForm">
  <mat-radio-group
    class="link-account-radio-group gap-3"
    formControlName="selected">
    <mat-radio-button
      *ngFor="let enrollment of enrollments"
      class="radio-button enrollment-list-item"
      [value]="enrollment"
      aria-label="{{
        'accessibility.redeem_cash_v2.checkout.enrollment_option'
          | translate
            : {
                product: productType(enrollment),
                digits: enrollment.groupReferenceId.toString().substr(-4)
              }
      }}">
      <p aria-hidden="true" class="enrollment-product-type font-semibold">
        {{ productType(enrollment) }}
      </p>
      <p aria-hidden="true" class="enrollment-group-reference-id">
        {{ displayedAccountNumber(enrollment.groupReferenceId) }}
      </p>
    </mat-radio-button>
  </mat-radio-group>
</div>
